import React from "react";
import { SText, STheme, SView } from "servisofts-component2";
import InputSelector from "../../../Components/Selectores/InputSelector";
import { TextInput } from "react-native";
import MDL from "../../../MDL";
import Input from "../../../Components/Input";
export default class QuestionItem extends React.Component<{ pregunta: any, id_checklist: any, rowKey?: string, isLastItem?: boolean, isSelected?: boolean, onFocusInput?: (...args: any[]) => void, onBlurInput?: (...args: any[]) => void }> {
    onChange = async (value: any) => {
        const body = {
            id_pregunta: this.props.pregunta.id,
            id_checklist: this.props.id_checklist,
            value: value,
            url_path: "",
        }
        await MDL.checklist.setChecklistDetalle(body);
        this.props.pregunta.respuesta = {
            respuesta: value,
        }
    }
    getPreguntaOptions() {
        return this.props.pregunta.data.map((item: any) => {
            return {
                key: item,
                value: item,
                label: item,
            }
        })
    }
    render() {
        const pregunta = this.props.pregunta;
        const isSelected = !!this.props.isSelected;
        return <SView col="xs-12" style={{ paddingVertical: 8, alignItems: "center", justifyContent: "space-between", 
            // paddingHorizontal: 8, borderRadius: 10, 
            // backgroundColor: isSelected ? STheme.color.secondary + "22" : "transparent", borderWidth: isSelected ? 1 : 0,
            //  borderColor: isSelected ? STheme.color.secondary : "transparent"
             }}
              row onPress={() => {
            this.props.onFocusInput?.(String(this.props.rowKey ?? ""), false, !!this.props.isLastItem);
        }}>
            <SText fontSize={16} style={{ flex: 1, flexShrink: 1, marginRight: 8 }}>{pregunta.pregunta}{pregunta.requerido > 0 && <SText fontSize={16} color={STheme.color.danger}>*</SText>}</SText>
            {/* <SText fontSize={16} style={{ flex: 1, flexShrink: 1, marginRight: 8, justifyContent: "flex-start" }}>{pregunta.pregunta}{pregunta.requerido > 0 && <SText fontSize={16} color={STheme.color.danger}>*</SText>}</SText> */}
            <SView width={4} height={1} />
            {pregunta.tipo_pregunta == "check" && <TypeCheck onChange={this.onChange} defaultValue={this.props.pregunta?.respuesta?.respuesta} onFocusInput={this.props.onFocusInput} rowKey={this.props.rowKey} isLastItem={this.props.isLastItem} />}
            {pregunta.tipo_pregunta == "select" && <TypeSelect options={this.getPreguntaOptions()} onChange={this.onChange} defaultValue={this.props.pregunta?.respuesta?.respuesta} onFocusInput={this.props.onFocusInput} rowKey={this.props.rowKey} isLastItem={this.props.isLastItem} />}
            {pregunta.tipo_pregunta == "number" && <TypeNumber onChange={this.onChange} defaultValue={this.props.pregunta?.respuesta?.respuesta} onFocusInput={this.props.onFocusInput} onBlurInput={this.props.onBlurInput} rowKey={this.props.rowKey} isLastItem={this.props.isLastItem} />}
        </SView>
    }
}
const TypeNumber = ({ onChange = (e: any) => { }, defaultValue = "", onFocusInput = (..._args: any[]) => { }, onBlurInput = (..._args: any[]) => { }, rowKey = "", isLastItem = false }: { onChange?: (e: any) => void, defaultValue?: string, onFocusInput?: (...args: any[]) => void, onBlurInput?: (...args: any[]) => void, rowKey?: string, isLastItem?: boolean }) => {
    const [value, setValue] = React.useState(defaultValue);
    const handleChange = (text: string) => {
        const normalizedValue = String(text ?? "").replace(/,/g, ".").replace(/[^0-9.]/g, "");
        const parts = normalizedValue.split(".");
        const integerPart = parts[0] ?? "";
        const decimalPart = parts.slice(1).join("").slice(0, 2);
        const numericValue = parts.length > 1
            ? `${integerPart}.${decimalPart}`
            : integerPart;
        setValue(numericValue);
        onChange(numericValue);
    };
    return <SView row style={{ width: 78, alignItems: 'center', justifyContent: 'flex-end' }}>
        <TextInput
            onChangeText={handleChange}
            value={value}
            maxLength={6}
            keyboardType="decimal-pad"
            onFocus={() => onFocusInput(String(rowKey), false, isLastItem)}
            onBlur={() => onBlurInput(String(rowKey), isLastItem)}
            style={{ width: '100%', minWidth: 78, height: 40, textAlign: 'center', color: STheme.color.text, flex: 1, margin: 0, padding: 0, backgroundColor: STheme.color.lightGray + "22", borderRadius: 4 }}
        />
    </SView>
}

const TypeSelect = ({ options = [], onChange = (e: any) => { }, defaultValue = "", 
onFocusInput = (..._args: any[]) => { }, rowKey = "", isLastItem = false }: 
{ options?: any[], onChange?: (e: any) => void, defaultValue?: string, 
    onFocusInput?: (...args: any[]) => void, rowKey?: string, isLastItem?: boolean }) => {
    return <SView row style={{ width: 78, alignItems: 'center', justifyContent: 'flex-end' }}>
        {/* <SView style={{ width: '100%' }}> */}
            <InputSelector
                autoSelectOnBlur
                options={options}
                defaultValue={defaultValue}
                style={{ width: '100%' }}
                rowKey={rowKey}
                isLastItem={isLastItem}
                onFocusInput={onFocusInput}
                onSelect={(e) => {
                    onChange(e.value);
                    onFocusInput(String(rowKey), false, isLastItem);
                }}
            />
        {/* </SView> */}
    </SView>
}









const TypeCheck = ({ onChange = (e: any) => { }, defaultValue = "", onFocusInput = (..._args: any[]) => { }, rowKey = "", isLastItem = false }: { onChange?: (e: any) => void, defaultValue?: string, onFocusInput?: (...args: any[]) => void, rowKey?: string, isLastItem?: boolean }) => {
    const [value, setValue] = React.useState(defaultValue);
    const handleChange = (newValue: any) => {
        setValue(newValue);
        onChange(newValue);
    };
    const boxStyle = { width: 30, height: 30, borderWidth: 2, borderColor: "#000", borderRadius: 4, }
    return <SView row style={{ gap: 16, justifyContent: 'flex-end' }}>
        <SView center style={[boxStyle, { borderColor: STheme.color.danger }, value == "NO" ? { backgroundColor: STheme.color.danger } : {}]}
            onPress={() => {
                onFocusInput(String(rowKey), false, isLastItem);
                if (value == "NO") {
                    handleChange("");
                    return;
                }
                handleChange("NO");
            }}>
            {value == "NO" ? <SText font='AlbertSans' bold fontSize={16} color={STheme.color.white}>✕</SText> : null}</SView>
        <SView center 
        style={[boxStyle, { borderColor: STheme.color.secondary }, value == "SI" ? { backgroundColor: STheme.color.secondary } : {}]}
            onPress={() => {
                onFocusInput(String(rowKey), false, isLastItem);
                if (value == "SI") {
                    handleChange("");
                    return;
                }
                handleChange("SI");
            }}
        >
            {value == "SI" ? <SText font='AlbertSans' bold fontSize={16} color={STheme.color.background}>✔</SText> : null}
        </SView>
    </SView>
}